import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const RouteTitleUpdater = () => {
    const location = useLocation();

    useEffect(() => {
        switch (location.pathname) {
            case '/':
                document.title = 'Добро пожаловать — Журнал «Поток»';
                break;
            case '/auth/login':
                document.title = 'Вход — Журнал «Поток»';
                break;
            case '/auth/registration':
                document.title = 'Регистрация — Журнал «Поток»';
                break;
            case '/auth/logout':
                document.title = 'Выполняется выход — Журнал «Поток»';
                break;
            case '/home':
                document.title = 'Главная — Журнал «Поток»';
                break;
            case '/appointments':
                document.title = 'Назначения — Журнал «Поток»';
                break;
            case '/complaints':
                document.title = 'Жалобы — Журнал «Поток»';
                break;
            case '/other-cases':
                document.title = 'Общие — Журнал «Поток»';
                break;
            case '/types-categories-phases':
                document.title = 'Категории и этапы — Журнал «Поток»';
                break;
            case '/users':
                document.title = 'Пользователи — Журнал «Поток»';
                break;
            case '/deactivated-accounts':
                document.title = 'Деактивированные учётные записи — Журнал «Поток»';
                break;
            case '/view-feedback':
                document.title = 'Просмотр обращений обратной связи — Журнал «Поток»';
                break;
            case '/emails-arbitration-managers':
                document.title = 'Адреса арбитражных управляющих — Журнал «Поток»';
                break;
            case '/inbox':
                document.title = 'Уведомления — Журнал «Поток»';
                break;
            case '/privacy-policy':
                document.title = 'Пользовательское соглашение и политика конфиденциальности — Журнал «Поток»';
                break;
            default:
                document.title = 'Журнал «Поток»';
        }
    }, [location]);

    return null;
};

export default RouteTitleUpdater;
